var map = {
	"./social-500px.svg": 204,
	"./social-dribbble.svg": 205,
	"./social-facebook.svg": 206,
	"./social-github.svg": 207,
	"./social-google.svg": 208,
	"./social-instagram.svg": 209,
	"./social-odnoklassniki.svg": 210,
	"./social-rediit.svg": 211,
	"./social-stackoverflow.svg": 212,
	"./social-steam.svg": 213,
	"./social-twitch.svg": 214,
	"./social-twitter.svg": 215,
	"./social-vkontakte.svg": 216,
	"./social-windows.svg": 217,
	"./social-yahoo.svg": 218
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 203;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars ^\.\/social\-.*\.svg$
// module id = 203
// module chunks = 0